import React from 'react'
import SingleSelectDropdown from './SingleSelectDropdown'
import type { ComparisonMode } from '@/types/calendar'

interface ComparisonSelectorProps {
  value: ComparisonMode
  onChange: (mode: ComparisonMode) => void
}

const options = [
  { value: 'none', label: 'None' },
  { value: 'base_rate', label: 'Base Rate' },
  { value: 'yesterday', label: "Yesterday's Price" },
  { value: 'last_week', label: "Last Week's Price" },
]

export default function ComparisonSelector({ value, onChange }: ComparisonSelectorProps) {
  return (
    <SingleSelectDropdown
      label="Compare to"
      options={options}
      value={value}
      onChange={(v) => onChange(v as ComparisonMode)}
    />
  )
}
